const IsIframedInSeismic = ({ children, show = true }) => {
  const isIframedInSeismic = sessionStorage.getItem('iframedInSeismic');

  if (!isIframedInSeismic) return children;
  if (isIframedInSeismic && show) return children;
  if (isIframedInSeismic && !show) return null;
  return null;
};

export default IsIframedInSeismic;
